import React from "react";

export const LogoutIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.46875 10.875L9.46875 13.8437C9.46875 14.3162 9.28108 14.7692 8.94703 15.1033C8.61298 15.4373 8.15992 15.625 7.6875 15.625L2.9375 15.625C2.46508 15.625 2.01201 15.4373 1.67796 15.1033C1.34392 14.7692 1.15625 14.3162 1.15625 13.8437L1.15625 3.15625C1.15625 2.68383 1.34392 2.23077 1.67797 1.89672C2.01202 1.56267 2.46508 1.375 2.9375 1.375L7.6875 1.375C8.15992 1.375 8.61299 1.56267 8.94703 1.89672C9.28108 2.23077 9.46875 2.68383 9.46875 3.15625L9.46875 6.125M11.8438 6.125L14.2188 8.5M14.2188 8.5L11.8438 10.875M14.2188 8.5L4.125 8.5"
        stroke="#1C1C1C"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
